import * as React from 'react';
import * as colors from '../../consts/variables';

const hamburgerStyles: any = {
    width: '24px',
    marginLeft: '15px',
};
const hamburgerBarStyles: any = {
    display: 'block',
    width: '100%',
    borderRadius: '10px',
    height: '2px',
    background: colors.lighterBlack,
    marginTop: '5px',
};
const firstHamburgerBarStyle: any = {
    ...hamburgerBarStyles,
    marginTop: '0',
};

interface Props {
    onClick: React.EventHandler<any>;
}

export function BurgerButton(props: Props) {
    return (
        <div style={hamburgerStyles} onClick={props.onClick}>
            <span style={firstHamburgerBarStyle}></span>
            <span style={hamburgerBarStyles}></span>
            <span style={hamburgerBarStyles}></span>
        </div>
    );
}
